import { State } from 'utils/state';

/**
 * Local-only, reactive signal-health flag (AVS-4330). `degraded` is true while the broadcast
 * socket has given up reconnecting and the client is on the slow-poll read-repair fallback.
 *
 * Deliberately a standalone `State`, NOT a `userSession` field: a session field would trip
 * `syncToServer`'s "no relevant keys changed" branch and emit an `emitOnly` broadcast on every
 * toggle. A UI indicator can subscribe to this directly.
 */
export const syncStatus = new State<{ degraded: boolean }>({ degraded: false });

/** Set the degraded flag; only writes (and emits) when the value actually changes. */
export function setSyncDegraded(degraded: boolean): void {
  if (syncStatus.get('degraded') !== degraded) {
    syncStatus.setValues({ degraded });
  }
}

export function isSyncDegraded(): boolean {
  return syncStatus.get('degraded');
}
